class HomeMessage {
    title: string;
    message: string;
    variant: string;
}

class HomeListEntry {
    title: string;
    id: number;
    customCallToActionText?:string;
    customCallToActionUrl?:string;
}

class HomeModel {
    messages: HomeMessage[] = [];
    entries: HomeListEntry[] = [];
}

export { HomeListEntry, HomeMessage, HomeModel };
